import { BaseModel } from '@tcc-mono/shared/data-access';

export class Contact extends BaseModel {
  id: number;
  relation_id: number;
  relation_name?: string;
  name: string;
  phone?: string;
  email?: string;
}
